$(document).ready ->
  if $('.blueprint-wizard').length > 0
    eng_l_id = $('#eng_lang_id').attr("data-id")
    dutch_l_id = $('#dutch_lang_id').attr("data-id")
    default_l_id = $('#default_lang_id').attr("data-id")
    counter_for_blueprint = 4
    
    $('#s1, #s2, #s3').sortable({cancel: '.chapter-name', connectWith: '.blueprint-boxes-sortable'})
    $('.blueprint-boxes-droppable').droppable({tolerance: "pointer", accept: ".blueprint-boxes-draggable"})
    $('.blueprint-boxes-draggable').draggable({revert: true})

    if $(window).height() >= 980
      $('.blueprint-wizard .blueprint-data .blueprint-library').css("max-height", "714px")
    else
      $('.blueprint-wizard .blueprint-data .blueprint-library').css("max-height", "367px")

    $('#bp_select_langugage').change (event) ->
      if $(event.target).val() == "Dutch"
        $('.library-chapter-english').css("display", "none")
        $('.chapter-english').css("display", "none")
        $('.story-english').css("display", "none")
        $('.library-topic-english').css("display", "none")
        $('.library-chapter-dutch').css("display", "block")
        $('.chapter-dutch').css("display", "block")
        $('.story-dutch').css("display", "block")
        $('.library-topic-dutch').css("display", "block")
      else
        $('.library-chapter-dutch').css("display", "none")
        $('.chapter-dutch').css("display", "none")
        $('.story-dutch').css("display", "none")
        $('.library-topic-dutch').css("display", "none")
        $('.library-chapter-english').css("display", "block")
        $('.chapter-english').css("display", "block")
        $('.story-english').css("display", "block")
        $('.library-topic-english').css("display", "block")

    $('.blueprint-boxes-draggable').on 'dragstart', (event, ui) ->
      $('.blueprint-boxes-draggable').removeClass('selected')
      $('.blueprint-library').css("overflow", "visible")
      $('.blueprint-boxes-droppable').addClass("dropzone")

    $('.blueprint-boxes-draggable').on 'dragstop', (event, ui) ->
      $('.blueprint-library').css("overflow", "auto")
      $('.blueprint-boxes-droppable').removeClass("dropzone")

    $('.blueprint-boxes-draggable').click ->
      add_class = $(this).hasClass('selected')
      $('.blueprint-boxes-draggable').removeClass('selected')
      unless add_class
        $(this).addClass('selected')

    $('.blueprint-boxes-droppable').on 'drop', (event, ui) ->
      set_drop_event_listener(event, ui, this)

    $('.blueprint-boxes-sortable').on 'sortremove', (event, ui) ->
      replace_with = $(ui.item).parent().parent().attr("id")
      replace_text = $($(event.target)[0]).parent().attr("id")
      
      for item in $(ui.item).find('.chapter-name').find('input')
        name = $(item).attr("name")
        name = name.replace(replace_text, replace_with)
        $(item).attr("name", name)

    $('.remove-blueprint-story').click (event) ->
      remove_bluerprint_story(event)

    $('.add-a-chapter').click (event) ->
      dup = $('#blueprint-new-chapter').clone()
      dup.attr("id", "")
      dup.css("display", "inline-block")
      if !!$('#bp_select_langugage').val()
        dup.find('.chapter-english').find('#a').attr("data-key", counter_for_blueprint)
        dup.find('.chapter-dutch').find('#a').attr("data-key", counter_for_blueprint)
      else
        dup.find('#a').attr("data-key", counter_for_blueprint)

      story_id =  $(this).parent().parent().attr("id")
      if !!$('#bp_select_langugage').val()
        dup.find('.chapter-english').find('#a').attr("name", story_id + "[chapters]["+counter_for_blueprint+"][name][" + eng_l_id + "]")
        dup.find('.chapter-dutch').find('#a').attr("name", story_id + "[chapters]["+counter_for_blueprint+"][name][" + dutch_l_id + "]")
        if $('#bp_select_langugage').val() == "Dutch"
          dup.find('.chapter-english').css("display", "none")
          dup.find('.chapter-dutch').css("display", "block")
        else
          dup.find('.chapter-dutch').css("display", "none")
          dup.find('.chapter-english').css("display", "block")
      else
        dup.find('#a').attr("name", story_id + "[chapters]["+counter_for_blueprint+"][name][" + default_l_id + "]")
      counter_for_blueprint += 1

      dup.find('.remove-blueprint-story').click (event) ->
        remove_bluerprint_story(event)

      $(this).parent().siblings('.blueprint-boxes-sortable').append(dup)
      $(dup).droppable({tolerance: "pointer", accept: ".blueprint-boxes-draggable"})

      $(dup).on 'drop', (event, ui) ->
        set_drop_event_listener(event, ui, this)
     
    $(document).on 'keypress', 'form', (event) ->
      if event.keyCode == 13 
        $(event.target).blur()
      event.keyCode != 13
     
    remove_bluerprint_story =(event) ->
      library_chapters = $(event.target).parent().parent().find('.library-chapters')
      for library_chapter in library_chapters
        $("#" + $(library_chapter).attr("data-chapter-id")).css("display", "block")
      $(event.target).parent().parent().remove()

    set_drop_event_listener =(e, ui, object) ->
      draggableId = ui.draggable
      draggableId.css("display", "none")
      dup = $('#blueprint-new-topic').clone()
      if !!$('#bp_select_langugage').val()
        $($(dup).find('.library-topic-dutch')[0]).text($($(ui.draggable).find('.library-chapter-dutch')[0]).text())
        $($(dup).find('.library-topic-dutch')[0]).attr("title", ($($(ui.draggable).find('.library-chapter-dutch')[0]).text()))          
        $($(dup).find('.library-topic-english')[0]).text($($(ui.draggable).find('.library-chapter-english')[0]).text())
        $($(dup).find('.library-topic-english')[0]).attr("title", ($($(ui.draggable).find('.library-chapter-english')[0]).text()))
        if $('#bp_select_langugage').val() == "Dutch"
          $($(dup).find('.library-topic-english')[0]).css("display", "none")
          $($(dup).find('.library-topic-dutch')[0]).css("display", "block")
        else
          $($(dup).find('.library-topic-dutch')[0]).css("display", "none")
          $($(dup).find('.library-topic-english')[0]).css("display", "block")
      else
        $($(dup).find('.library-topic')[0]).text($($(ui.draggable).find('.chapter-name')[0]).text())
        $($(dup).find('.library-topic')[0]).attr("title", ($($(ui.draggable).find('.chapter-name')[0]).text()))
      dup.attr("id", "")
      dup.attr("data-chapter-id", $(ui.draggable).attr("id"))
      dup.css("display", "block")

      text_field = $($(object).find('.chapter-name').find('input')[0]).clone()
      text_field.attr("id", "")
      text_field.css("display", "none")
      story_id = $(object).parent().parent().attr("id")
      text_field.attr("name", story_id + "[chapters]["+text_field.attr("data-key")+"][id][]")
      text_field.val($($(ui.draggable).find('.chapter-name')[0]).attr("data-chapter-id"))
      $(dup).append(text_field)

      dup.find('.move-back-to-library').click (event) ->
        original = $(event.target).parent().parent().parent()
        $("#" + $(event.target).parent().parent().attr("data-chapter-id")).css("display", "block")
        $(event.target).parent().parent().remove()
        update_total_pages(original)

      $(object).append(dup)
      update_total_pages(object)
        
    update_total_pages =(object) ->
      library_chapters = $(object).find('.library-chapters')
      pages = 0
      for library_chapter in library_chapters
        pages += parseInt( $($("#" + $(library_chapter).attr("data-chapter-id")).find('.page-count')[0]).attr("data-pages-count") )
      if pages != 1
        $($(object).find('.page-count')[0]).text(pages.toString() + " PAGES")
      else
        $($(object).find('.page-count')[0]).text(pages.toString() + " PAGE")

